import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Phone, MessageCircle } from 'lucide-react';
import { COMPANY_INFO } from '../../data/mock';

const FinalCTASection = () => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-[#F0FDFA] via-white to-[#E0F2FE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111]">
            Ready to stop dealing with packaging?
          </h2>
          <p className="mt-6 text-lg text-[#475569]">
            Join installers across Metro Melbourne who've simplified their workflow with Transa.
          </p>
          
          {/* CTA Buttons */}
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/book/waste">
              <Button size="lg" className="w-full sm:w-auto bg-[#0D9488] hover:bg-[#0F766E] text-white px-10 py-6 text-lg font-semibold">
                Collect My Packaging
              </Button>
            </Link>
            <Link to="/pricing">
              <Button size="lg" variant="outline" className="w-full sm:w-auto border-[#E2E8F0] text-[#111111] hover:border-[#0D9488] hover:bg-[#F0FDFA] px-10 py-6 text-lg">
                Request Pricing
              </Button>
            </Link>
          </div>

          {/* Contact Options */}
          <div className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-6 text-[#475569]">
            <a 
              href={`tel:${COMPANY_INFO.phone}`}
              className="flex items-center gap-2 hover:text-[#0D9488] transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span>{COMPANY_INFO.phone}</span>
            </a>
            <span className="hidden sm:block text-[#E2E8F0]">|</span>
            <a 
              href={`https://wa.me/${COMPANY_INFO.whatsapp.replace(/\+/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#25D366] transition-colors"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
